export const formatBaleDensity = ({
  weight,
  height,
  width,
  length,
  roundTo,
}: {
  weight?: number | null;
  height?: number | null;
  width?: number | null;
  length?: number | null;
  roundTo?: number;
}) => {
  if (!weight || !height || !width || !length) {
    return null;
  }
  const density = weight / (height * width * length);

  if (roundTo) {
    return density.toFixed(roundTo);
  }

  return density;
};
